import { Box, CircularProgress, Image } from '@presov.sk/presov-ui-react';

const MapLoader = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Image
        src='/loadingMap.png'
        alt='Map is loading'
        sx={{
          objectFit: 'cover',
          width: '100%',
          height: '100%',
          filter: 'blur(2px)',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <CircularProgress
          size={50}
          sx={{
            color: 'primary.light',
          }}
        />
      </Box>
    </Box>
  );
};

export default MapLoader;
